/* eslint-disable max-len */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import moment from 'moment';
import { Link } from 'react-router-dom';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';

import styles from './TrialNotification.scss';// to import local scss fle


function TrialNotification(props) {
  return (
    <div className={cn('row', styles.container)}>
      <span className={cn('col s12', styles.notification)}>
        You are currently on a free trial which expires at {moment(props.trialEndDate).format('HH:MM on MMM DD YYYY')}. To contact coaches please click on menu and dashboard, then click contact coach for any you are interested in. Please upgrade your account to continue uninterrupted paid services.{' '}
        <Link to="/pricing" >
            Upgrade Now
        </Link>
      </span>
    </div>
  );
}

TrialNotification.propTypes = {
  trialEndDate: PropTypes.string.isRequired,
};

export default TrialNotification;




// WEBPACK FOOTER //
// ./src/components/TrialNotification/TrialNotification.js